import { useTranslation } from 'react-i18next';

export default function RegisterBenefits() {
  const { t } = useTranslation('register');

  const benefits = [
    { icon: 'ri-eye-line', title: t('benefit1Title'), description: t('benefit1Description') },
    { icon: 'ri-star-line', title: t('benefit2Title'), description: t('benefit2Description') },
    { icon: 'ri-phone-line', title: t('benefit3Title'), description: t('benefit3Description') },
    { icon: 'ri-bar-chart-line', title: t('benefit4Title'), description: t('benefit4Description') },
  ];

  return (
    <section className="py-16 md:py-24 bg-amber-50">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block text-xs md:text-sm font-semibold text-amber-600 uppercase tracking-widest mb-4">
            {t('benefitsLabel')}
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900">
            {t('benefitsTitle')}
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {benefits.map((b, i) => (
            <div key={i} className="bg-white rounded-xl p-6 md:p-8 text-center transition-all hover:shadow-lg">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 flex items-center justify-center bg-amber-100 rounded-full">
                <i className={`${b.icon} text-amber-600 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3">{b.title}</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">{b.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}